import { HttpErrorResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { catchError, map, of, switchMap } from 'rxjs';
import { divisionsActions } from '../actions/divisions.actions';
import { HttpService } from '../services/http.service';

@Injectable()
export class DivisionsEffects {
    private readonly actions = inject(Actions);
    private readonly httpService = inject(HttpService);

    getDivisions$ = createEffect(() => {
        return this.actions.pipe(
            ofType(divisionsActions.getDivisions),
            switchMap(({ value }) => {
                return this.httpService.getDivisions(value).pipe(
                    map((payload) => divisionsActions.getDivisionsSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(divisionsActions.getDivisionsError({ code: error.status }))),
                );
            }),
        );
    });

    getDivisionsLookup$ = createEffect(() => {
        return this.actions.pipe(
            ofType(divisionsActions.getDivisionsLookup),
            switchMap(() => {
                return this.httpService.getDivisionsLookup().pipe(
                    map((payload) => divisionsActions.getDivisionsLookupSuccess({ payload })),
                    catchError((error: HttpErrorResponse) => of(divisionsActions.getDivisionsLookupError({ code: error.status }))),
                );
            }),
        );
    });
}
